import React, { memo, useMemo } from "react";
import { getCustomColor, prepareBetNum } from "../../../constants/rollet";

const CircleGridMobile = ({ numbers, onBetting }) => {
    const preparedNumbers = useMemo(() => {
        return prepareBetNum(numbers || []);
    }, [numbers]);

    const handleBetting = (num) => {
        if (typeof onBetting === "function") {
            onBetting(num);
        }
    };

    return (
        <div className="rbm-number-grid">
            {preparedNumbers.map((num, index) => (
                <div key={num?.code || index} className="rbm-number-grid__cell">
                    <button
                        type="button"
                        onClick={() => handleBetting(num)}
                        className={`rbm-number-chip rbm-number-chip--${getCustomColor(num?.code)}`}
                    >
                        <span className="rbm-number-chip__code">{num?.code}</span>
                        <span className="rbm-number-chip__odds">{num?.value}</span>
                    </button>
                </div>
            ))}
        </div>
    );
};

export default memo(CircleGridMobile);